import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import { onMounted, ref } from "vue";
import { ErrorIcon, Icon } from "./Icons";
import LicenseCertification from "./LicenseCertification.vue";
import { queryLicense } from "@/data";
import { License } from "@/data/index.type";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseQuery',
  setup(__props) {

const route = useRoute();
const error = ref<string>();
const value = ref<string>();

const license = ref<License | undefined>();
const search = () => {
  error.value = undefined;
  if (!isValid(value.value)) {
    license.value = undefined;
    return;
  }
  queryLicense(value.value!).then((res) => {
    if (res.data.isSuccess && res.data.code === 200) {
      license.value = res.data.data;
    } else {
      error.value = res.data.msg;
      license.value = undefined;
    }
  });
};

const isValid = (value: string | undefined) => {
  if (value === undefined || value.trim() === "") {
    error.value = "查询的许可编码不能为空";
    return false;
  }
  return true;
};

onMounted(() => {
  value.value = route.query["license"]?.toString();
  if (value.value) search();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (license.value !== undefined)
      ? (_openBlock(), _createBlock(LicenseCertification, {
          key: 0,
          data: license.value
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.search)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.block)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['input-wrap'])
        }, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(_ctx.$style.input),
            type: "text",
            autocomplete: "off",
            placeholder: "请输入许可编码进行查询",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
          }, null, 2), [
            [_vModelText, value.value]
          ])
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(_ctx.$style.button),
          onClick: search
        }, "查询", 2)
      ], 2),
      (error.value !== undefined)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style.error)
          }, [
            _createVNode(_unref(Icon), {
              size: 30,
              color: "#ffa952",
              style: {"margin-right":"8px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ErrorIcon))
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(error.value), 1)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})